import { t } from 'i18next'

export const getErrorMessageOmiseCharge = (failureCode: string) => {
  let errorMsg = ''

  switch (failureCode) {
    case 'insufficient_balance':
    case 'insufficient_fund':
    case 'invalid_security_code':
    case 'stolen_or_lost_card':
    case 'failed_processing':
    case 'payment_rejected':
    case 'failed_fraud_check':
    case 'invalid_account_number':
    case 'invalid_account':
      errorMsg = t(failureCode)
      break
    default:
      errorMsg = ''
  }

  return errorMsg
}
